import React from 'react';
import HojaCaratula from './base/HojaCaratula';

// Etiquetas EXACTAS de la plantilla (templates/caratula/caratula_ganancias.docx): el modal es
// una vista previa, así que lo que se lee acá tiene que coincidir renglón por renglón con el
// papel. `guardable` marca los que además de imprimirse vuelven al cliente/trámite (ver
// CaratulaGananciasDocumentoService.persistirDatosGuardables).
const CAMPOS = {
    ingreso: { label: 'INGRESO', tipo: 'fecha' },
    claveAnses: {
        label: 'CLAVE ANSES', tipo: 'clave', guardable: true,
        nota: 'Clave de la Seguridad Social del cliente. Se guarda en su ficha; vacía no borra la que ya tiene.',
    },
    claveFiscal: {
        label: 'CLAVE FISCAL', tipo: 'clave', guardable: true,
        nota: 'Clave fiscal (AFIP) del cliente. Se guarda en su ficha; vacía no borra la que ya tiene.',
    },
    claveCidi: {
        label: 'CLAVE CIDI', tipo: 'clave', guardable: true,
        nota: 'Clave CIDI del cliente. Se guarda en su ficha; vacía no borra la que ya tiene.',
    },
    referencia: { label: 'REFERENCIA', tipo: 'texto' },
    pacto: {
        label: 'PACTO', tipo: 'texto',
        nota: 'Sale del check de Pacto del trámite. Editarlo acá no cambia la ficha.',
    },

    apellidoNombre: { label: 'APELLIDO/NOMBRE TITULAR', tipo: 'texto' },
    dniCuit: { label: 'DNI/CUIT', tipo: 'texto' },
    fechaNacimiento: { label: 'FECHA DE NACIMIENTO', tipo: 'fecha', guardable: true, noFutura: true },
    telefono: {
        label: 'Nº TELEFONICO', tipo: 'texto', guardable: true,
        nota: 'Trae el teléfono propio y los contactos adicionales del cliente. Solo vuelve a la ficha si dejás un único número.',
    },
    domicilioDni: {
        label: 'DOMICILIO DNI', tipo: 'domicilio', estructurado: 'domicilioDniDatos', guardable: true,
        nota: 'Se guarda en el domicilio DNI del cliente (el barrio que ya tenga se conserva). Vacío no borra nada.',
    },
    estadoCivil: { label: 'ESTADO CIVIL', tipo: 'estadoCivil', guardable: true },
    conyuge: { label: 'CON', tipo: 'texto', guardable: true },
    quienPaga: {
        label: '¿QUIEN PAGA LA JUBILACION?', tipo: 'texto',
        nota: 'Organismo que retiene el impuesto, cargado en el trámite. Editarlo acá no cambia la ficha.',
    },
    numeroBeneficio: { label: 'NUMERO DE BENEFICIO', tipo: 'texto', guardable: true },
    estudiosMedicos: { label: '¿TIENE ESTUDIOS MEDICOS?', tipo: 'texto', guardable: true },
    diaFirmaDemanda: {
        label: 'DIA QUE SE FIRMO DEMANDA', tipo: 'fecha',
        nota: 'Fecha de demanda presentada del trámite. Editarla acá no cambia la ficha.',
    },
    mail: { label: 'MAIL', tipo: 'email', guardable: true },
    observaciones: { label: 'OBSERVACIONES', tipo: 'multilinea', guardable: true },
};

const SEPARADOR = { separador: true };

// Las claves van en una tabla de dos columnas, igual que en el papel.
const TABLA_CLAVES = {
    tabla: {
        anchoMaximo: '420px',
        filas: [
            [{ texto: 'CLAVE ANSES' }, 'claveAnses'],
            [{ texto: 'CLAVE FISCAL' }, 'claveFiscal'],
            [{ texto: 'CLAVE CIDI' }, 'claveCidi'],
        ],
    },
};

// INGRESO, claves y REFERENCIA/PACTO van fuera del recuadro; adentro, cada bloque separado por
// una línea. DNI/CUIT y FECHA DE NACIMIENTO comparten bloque en el papel (sin línea entre ellos).
const FILAS_PREVIAS = [['ingreso'], TABLA_CLAVES, ['referencia', 'pacto']];
const FILAS_CUERPO = [
    ['apellidoNombre'],
    SEPARADOR,
    { keys: ['dniCuit', 'fechaNacimiento'], apilado: true },
    SEPARADOR,
    ['telefono'],
    SEPARADOR,
    ['domicilioDni'],
    SEPARADOR,
    ['estadoCivil', 'conyuge'],
    SEPARADOR,
    ['quienPaga'],
    SEPARADOR,
    ['numeroBeneficio'],
    SEPARADOR,
    ['estudiosMedicos'],
    SEPARADOR,
    ['diaFirmaDemanda'],
    SEPARADOR,
    ['mail'],
    SEPARADOR,
    ['observaciones'],
];

// Una sola plantilla, sin variantes. Título alineado a la izquierda y sin pie, como el papel.
const LAYOUT = {
    tituloDoc: 'RECLAMO ART 9 LEY 24463',
    alineacionTitulo: 'left',
    cabecera: [],
    filasPrevias: FILAS_PREVIAS,
    cuerpo: FILAS_CUERPO,
    pie: null,
};

/**
 * Modal de la Carátula de Impuesto a las Ganancias. Muestra los renglones prellenados (lo que
 * ya está en el cliente/trámite) y en blanco lo que falta, para completar antes de generar. Al
 * confirmar, "Guardar y generar" persiste los renglones guardables y emite el .docx con el DTO
 * tal cual quedó en el formulario (WYSIWYG).
 */
export default function ModalCaratulaGanancias(props) {
    return (
        <HojaCaratula
            {...props}
            titulo="Generar Carátula de Impuesto a las Ganancias"
            nombreDocumento="la Carátula de Impuesto a las Ganancias"
            campos={CAMPOS}
            layout={LAYOUT}
        />
    );
}
